"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLendingPools = getLendingPools;
exports.getLendingPool = getLendingPool;
exports.getLendingPoolAvailableRedemptions = getLendingPoolAvailableRedemptions;
exports.getLendingPoolApr = getLendingPoolApr;
exports.getLendingPoolTvl = getLendingPoolTvl;
const utils_1 = require("@augustdigital/utils");
const addresses_1 = require("./addresses");
const helpers_1 = require("./helpers");
const ethers_1 = require("ethers");
const abis_1 = require("@augustdigital/abis");
const EthDater = require('ethereum-block-by-date');
function getLendingPools(_a) {
    return __awaiter(this, arguments, void 0, function* ({ rpcUrl, optionalFields, }) {
        const provider = (0, utils_1.createProvider)(rpcUrl);
        const network = yield provider.getNetwork();
        const networkPools = addresses_1.default[Number(network.chainId)];
        let lendingPools = yield (0, helpers_1.getPoolsData)(Object.values(networkPools), rpcUrl);
        if (optionalFields === null || optionalFields === void 0 ? void 0 : optionalFields.loans) {
            try {
                lendingPools = yield Promise.all(lendingPools.map((p) => __awaiter(this, void 0, void 0, function* () {
                    const loans = yield (0, helpers_1.getPoolLoans)(p, rpcUrl);
                    const loanData = yield (0, helpers_1.getPoolLoansData)(p, loans, rpcUrl);
                    return Object.assign(Object.assign({}, p), loanData);
                })));
            }
            catch (e) {
                console.error('#getLendingPools::loans_or_aprs:', e);
            }
        }
        console.log('#getLendingPools:', lendingPools);
        return lendingPools;
    });
}
function getLendingPool(_a) {
    return __awaiter(this, arguments, void 0, function* ({ pool, rpcUrl, optionalFields, }) {
        let [returnedPool] = yield (0, helpers_1.getPoolsData)([pool], rpcUrl);
        try {
            if (optionalFields === null || optionalFields === void 0 ? void 0 : optionalFields.loans) {
                const loans = yield (0, helpers_1.getPoolLoans)(returnedPool, rpcUrl);
                const loanData = yield (0, helpers_1.getPoolLoansData)(returnedPool, loans, rpcUrl);
                returnedPool = Object.assign(Object.assign({}, returnedPool), loanData);
            }
        }
        catch (e) {
            console.error('#getLendingPool::loans_or_aprs:', e);
        }
        console.log('#getLendingPool:', returnedPool);
        return returnedPool;
    });
}
function getLendingPoolAvailableRedemptions(_a) {
    return __awaiter(this, arguments, void 0, function* ({ pool, address, rpcUrl, }) {
        var _b;
        const provider = (0, utils_1.createProvider)(rpcUrl);
        const poolContract = (0, utils_1.createContract)({
            address: pool,
            abi: abis_1.ABI_LENDING_POOLS,
            provider,
        });
        const logs = yield poolContract.queryFilter('WithdrawalRequested', BigInt(20483695));
        const iface = new ethers_1.ethers.Interface([
            'event WithdrawalRequested (address ownerAddr, address receiverAddr, uint256 shares, uint256 assets, uint256 fee, uint256 year, uint256 month, uint256 day)',
        ]);
        const events = logs.map((log) => iface.parseLog(log));
        const decimals = yield ((_b = poolContract === null || poolContract === void 0 ? void 0 : poolContract.decimals) === null || _b === void 0 ? void 0 : _b.call(poolContract));
        const availableRedemptions = [];
        events.forEach((ev) => {
            if (!(ev === null || ev === void 0 ? void 0 : ev.args))
                return;
            const [ownerAddr, receiverAddr, shares, assets, bnFee, bnYear, bnMonth, bnDay,] = ev.args;
            if (process.env.NODE_ENV === 'test') {
                console.log('ownerAddr:', ownerAddr);
                console.log('shares:', shares);
            }
            if (address && receiverAddr === address) {
                const [year, month, day] = [
                    (0, utils_1.toNormalizedBn)(bnYear, 0),
                    (0, utils_1.toNormalizedBn)(bnMonth, 0),
                    (0, utils_1.toNormalizedBn)(bnDay, 0),
                ];
                availableRedemptions.push({
                    receiver: receiverAddr,
                    day,
                    month,
                    year,
                    amount: (0, utils_1.toNormalizedBn)(assets, decimals),
                    date: new Date(Number(bnYear), Number(bnMonth) - 1, Number(bnDay)),
                });
            }
        });
        console.log('#getLendingPoolAvailableRedemptions:', availableRedemptions);
        return availableRedemptions;
    });
}
function getLendingPoolApr(_a) {
    return __awaiter(this, arguments, void 0, function* ({ pool, rpcUrl, inputParams, }) {
        if (typeof inputParams === 'undefined') {
            let [returnedPool] = yield (0, helpers_1.getPoolsData)([pool], rpcUrl);
            const loans = yield (0, helpers_1.getPoolLoans)(returnedPool, rpcUrl);
            const loanData = yield (0, helpers_1.getPoolLoansData)(returnedPool, loans, rpcUrl);
            returnedPool = Object.assign(Object.assign({}, returnedPool), loanData);
            return {
                timestamp: Math.floor(new Date().getTime() / 1000),
                value: loanData.apy,
            };
        }
        if (typeof inputParams !== 'undefined' && !inputParams.order)
            inputParams.order = 'desc';
        if (typeof inputParams !== 'undefined' && !inputParams.interval)
            inputParams.interval = 'days';
        const provider = (0, utils_1.createProvider)(rpcUrl);
        let [returnedPool] = yield (0, helpers_1.getPoolsData)([pool], rpcUrl);
        const allLoans = yield (0, helpers_1.getPoolLoans)(returnedPool, rpcUrl);
        const dater = new EthDater(provider);
        const blocks = yield dater.getEvery(inputParams.interval, inputParams.start.toUTCString(), new Date().toUTCString());
        const orderedBlocks = inputParams.order === 'desc' ? (0, utils_1.orderObjArrByDate)(blocks) : blocks;
        const minAbi = ['function currentApr() view returns (uint256)', 'function principalAmount() view returns (uint256)'];
        const loanAprsHistorical = yield Promise.all(orderedBlocks === null || orderedBlocks === void 0 ? void 0 : orderedBlocks.map((_a) => __awaiter(this, [_a], void 0, function* ({ block, date }) {
            let aggregateApr = BigInt(0);
            const amountOfLoans = BigInt(allLoans.length || 0);
            const loansApr = yield Promise.all(allLoans.map((l) => __awaiter(this, void 0, void 0, function* () {
                const loanContract = (0, utils_1.createContract)({
                    address: l,
                    abi: abis_1.ABI_LOAN,
                    provider,
                });
                const loanAprAtBlock = yield provider.call({
                    to: loanContract,
                    data: new ethers_1.Interface(minAbi).encodeFunctionData('currentApr', []),
                    blockTag: block,
                });
                if (loanAprAtBlock === '0x')
                    return {
                        timestamp: (0, utils_1.dateToUnix)(new Date(date)),
                        value: (0, utils_1.toNormalizedBn)(0, 0),
                    };
                const readableLoanAprAtBlock = new ethers_1.Interface(minAbi).decodeFunctionResult('currentApr', loanAprAtBlock);
                aggregateApr += readableLoanAprAtBlock === null || readableLoanAprAtBlock === void 0 ? void 0 : readableLoanAprAtBlock[0];
                return {
                    timestamp: (0, utils_1.dateToUnix)(new Date(date)),
                    value: (0, utils_1.toNormalizedBn)(readableLoanAprAtBlock === null || readableLoanAprAtBlock === void 0 ? void 0 : readableLoanAprAtBlock[0], 2),
                };
            })));
            return {
                timestamp: (0, utils_1.dateToUnix)(new Date(date)),
                value: (0, utils_1.toNormalizedBn)(aggregateApr / amountOfLoans, 2)
            };
        })));
        console.log("#getLendingPoolApr:", loanAprsHistorical);
        return loanAprsHistorical;
    });
}
function getLendingPoolTvl(_a) {
    return __awaiter(this, arguments, void 0, function* ({ pool, rpcUrl, inputParams, }) {
        if (typeof inputParams === 'undefined') {
            let [returnedPool] = yield (0, helpers_1.getPoolsData)([pool], rpcUrl);
            const returnObj = {
                timestamp: (0, utils_1.dateToUnix)(new Date()),
                value: returnedPool.totalAssets,
            };
            console.log("#getLendingPoolTvl:", returnObj);
            return returnObj;
        }
        if (typeof inputParams !== 'undefined' && !inputParams.order)
            inputParams.order = 'desc';
        if (typeof inputParams !== 'undefined' && !inputParams.interval)
            inputParams.interval = 'days';
        const provider = (0, utils_1.createProvider)(rpcUrl);
        const poolContract = (0, utils_1.createContract)({
            address: pool,
            abi: abis_1.ABI_LENDING_POOLS,
            provider,
        });
        const dater = new EthDater(provider);
        const blocks = yield dater.getEvery(inputParams.interval, inputParams.start.toUTCString(), new Date().toUTCString());
        const orderedBlocks = inputParams.order === 'desc' ? (0, utils_1.orderObjArrByDate)(blocks) : blocks;
        const minAbi = ['function totalAssets() view returns (uint256)'];
        const totalAssetsHistorical = yield Promise.all(orderedBlocks === null || orderedBlocks === void 0 ? void 0 : orderedBlocks.map((_a) => __awaiter(this, [_a], void 0, function* ({ block, date }) {
            const totalAssetsAtBlock = yield provider.call({
                to: poolContract,
                data: new ethers_1.Interface(minAbi).encodeFunctionData('totalAssets', []),
                blockTag: block,
            });
            if (totalAssetsAtBlock === '0x')
                return {
                    timestamp: (0, utils_1.dateToUnix)(new Date(date)),
                    value: (0, utils_1.toNormalizedBn)(0, 0)
                };
            const readableTotalAssetsAtBlock = new ethers_1.Interface(minAbi).decodeFunctionResult('totalAssets', totalAssetsAtBlock);
            return {
                timestamp: (0, utils_1.dateToUnix)(new Date(date)),
                value: (0, utils_1.toNormalizedBn)(readableTotalAssetsAtBlock === null || readableTotalAssetsAtBlock === void 0 ? void 0 : readableTotalAssetsAtBlock[0])
            };
        })));
        console.log("#getLendingPoolTvl:", totalAssetsHistorical);
        return totalAssetsHistorical;
    });
}
//# sourceMappingURL=getters.js.map